<template>
    <div class="activity-button" :data-bot="dataBot" v-on="$listeners">
        <CompassObject :object="object" size="extra-small" />
        <button class="typographies-paragraph-medium-semibold">{{ label }}</button>
    </div>
</template>
<script>
export default {
    props: {
        object: {
            type: String,
            default: () => {},
        },
        label: {
            type: String,
            default: '',
        },
        dataBot: {
            type: String,
            default: '',
        },
    },
};
</script>
<style lang="scss" scoped>
.activity-button {
    align-items: center;
    background: var(--colors-common-background-default);
    border: 1px solid var(--colors-common-border-default);
    border-radius: var(--spacing-0);
    color: var(--colors-common-text-standard-default);
    cursor: pointer;
    display: inline-flex;
    gap: var(--spacing-1);
    padding: 5px 7px 5px 5px;
    transition: all 100ms cubic-bezier(0, 0, 0.3, 1);

    &:hover {
        border-color: var(--colors-common-border-default-hover);
    }

    &::v-deep {
        .compass-icon {
            height: 20px;
            width: 20px;
        }
    }

    button {
        background: transparent;
        border: 0;
        cursor: pointer;
        padding: 0;
    }
}
</style>
